import { Injectable } from '@angular/core';

@Injectable()
export class Variables {
    public language: string;
    public token: string;
    public loginError: boolean;
    public appSettings: Map<string, string>;
    public defaultTexts: Map<string, string>;

    public getAPIBaseURL() {
        try {
            return this.appSettings["API:BaseURL"] + this.appSettings["API:Version"] + '/';
        } catch {
            return '/';
        }
    }

    public getAPIAuthURL() {
        try {
            return this.appSettings["API:Auth:BaseURL"] + this.appSettings["API:Auth:Version"] + '/';
        } catch {
            return '/';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/variables.ts